<template>
  <div class="promotion-6-plus-1-view default-page">
    <img
      :src="bannerImage"
      alt="Акція 6+1 від Crystal"
      class="default-page__banner mb-5"
    />
    <h1>Акція «6+1»</h1>
    <div class="default-page-section">
      Оплатіть 6 місяців одразу – отримайте +1 в подарунок!
    </div>
    <div class="default-page-section">
      <ul>
        <li><span>📱</span> Завантажте застосунок My Crystal</li>
        <li><span>💳</span> Поповніть рахунок на суму 6 абонплат</li>
        <li><span>🎁</span> +1 місяць нарахується автоматично!</li>
      </ul>
    </div>
    <div class="default-page-section">
      💰 Ціна заморожується – жодних подорожчань на 7 місяців! ❄️🔒
    </div>
    <div class="default-page-section mb-0">
      <router-link :to="{ name: 'mobile-app' }">
        <app-btn class="btn btn-primary w-100">
          Завантажити застосунок
        </app-btn>
      </router-link>
    </div>
  </div>
</template>

<script>
import AppBtn from "@/components/common/ui/AppBtn.vue";
import bannerImage from "@/assets/promotions/banner-stock-1.jpg";

export default {
  name: "Promotion6plus1View",
  components: {
    AppBtn,
  },
  setup() {
    return {
      bannerImage,
    };
  },
};
</script>

<style scoped lang="less">
@import "@/styles/_mixins.less";

.promotion-6-plus-1-view {
  .default-page-section {
    .default-ul-list();
  }
}
</style>
